// extracted by mini-css-extract-plugin
module.exports = {"SuccessStory":"SuccessStory_SuccessStory__ihff2","imageWrapper":"SuccessStory_imageWrapper__MQw0O","quote":"SuccessStory_quote__Cce3x","title":"SuccessStory_title__HOrWk"};